import { render, staticRenderFns } from "./marketData.vue?vue&type=template&id=ba55d91a&scoped=true&"
import script from "./marketData.vue?vue&type=script&lang=js&"
export * from "./marketData.vue?vue&type=script&lang=js&"
import style0 from "./marketData.vue?vue&type=style&index=0&id=ba55d91a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba55d91a",
  null
  
)

export default component.exports